import { render, staticRenderFns } from "./ReportVisitorActivityPDF.vue?vue&type=template&id=196f0d5f&scoped=true&"
import script from "./ReportVisitorActivityPDF.vue?vue&type=script&lang=js&"
export * from "./ReportVisitorActivityPDF.vue?vue&type=script&lang=js&"
import style0 from "./ReportVisitorActivityPDF.vue?vue&type=style&index=0&id=196f0d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f0d5f",
  null
  
)

export default component.exports